export default __webpack_public_path__ + "static/media/Gauntlets of the Defiant.dda0af29.jpg";